import * as React from "react";

class ButtonGText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonG-text buttonFG-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M72.803,53.111h7.833v1.747h-5.744v3.691h4.861v1.765h-4.861v4.285h5.942v1.765h-8.031V53.111z"
          />
          <path
            fill="#FCFAEE"
            d="M82.847,63.734c0-2.125,1.801-3.223,5.924-3.673c-0.018-1.152-0.432-2.161-1.891-2.161
			c-1.044,0-2.017,0.468-2.863,1.008l-0.773-1.404c1.026-0.648,2.412-1.297,3.997-1.297c2.467,0,3.601,1.567,3.601,4.195v5.96
			h-1.692l-0.18-1.134h-0.054c-0.9,0.774-1.963,1.368-3.151,1.368C84.053,66.597,82.847,65.48,82.847,63.734z M88.771,63.806v-2.431
			c-2.935,0.36-3.925,1.098-3.925,2.214c0,0.972,0.666,1.369,1.548,1.369C87.258,64.958,87.96,64.544,88.771,63.806z"
          />
          <path
            fill="#FCFAEE"
            d="M92.729,65.229l0.972-1.333c0.883,0.702,1.747,1.134,2.81,1.134c1.188,0,1.746-0.576,1.746-1.333
			c0-0.9-1.116-1.296-2.196-1.71c-1.314-0.504-2.827-1.206-2.827-2.881c0-1.656,1.332-2.899,3.511-2.899
			c1.333,0,2.413,0.541,3.224,1.17l-0.973,1.279c-0.685-0.504-1.387-0.864-2.215-0.864c-1.08,0-1.584,0.54-1.584,1.224
			c0,0.846,1.026,1.17,2.106,1.566c1.387,0.522,2.917,1.134,2.917,3.007c0,1.657-1.314,3.007-3.764,3.007
			C95.087,66.597,93.683,66.021,92.729,65.229z"
          />
          <path
            fill="#FCFAEE"
            d="M101.71,61.429c0-3.313,2.215-5.222,4.663-5.222c2.449,0,4.664,1.909,4.664,5.222
			c0,3.277-2.215,5.167-4.664,5.167C103.925,66.597,101.71,64.707,101.71,61.429z M108.913,61.429c0-2.106-0.973-3.511-2.539-3.511
			c-1.548,0-2.521,1.404-2.521,3.511c0,2.089,0.973,3.475,2.521,3.475C107.94,64.904,108.913,63.518,108.913,61.429z"
          />
          <path
            fill="#FCFAEE"
            d="M113.464,56.46h1.692l0.162,1.368h0.054c0.919-0.882,1.927-1.621,3.277-1.621
			c2.106,0,3.043,1.405,3.043,3.925v6.23h-2.07v-5.978c0-1.711-0.505-2.395-1.675-2.395c-0.918,0-1.549,0.468-2.431,1.351v7.022
			h-2.053V56.46z"
          />
          <path
            fill="#FCFAEE"
            d="M128.819,59.881c-0.288,1.603-0.882,3.241-1.639,4.538c0.307,0.162,0.667,0.45,1.225,0.756
			c1.242,0.72,2.917,0.828,4.987,0.828c2.143,0,5.222-0.162,7.257-0.414c-0.217,0.45-0.505,1.296-0.522,1.765
			c-1.368,0.09-4.682,0.198-6.806,0.198c-2.323,0-3.871-0.18-5.204-0.937c-0.72-0.396-1.368-0.972-1.765-0.972
			c-0.396,0-1.044,1.134-1.548,2.179l-1.116-1.584c0.521-0.684,1.08-1.26,1.584-1.639l-0.018-0.018
			c0.773-0.936,1.386-2.305,1.746-3.619h-2.539c0.505-1.063,1.099-2.539,1.621-3.925h-2.071v-1.513h4.25
			c-0.469,1.278-1.045,2.755-1.566,3.998h0.9l0.233-0.054L128.819,59.881z M126.226,54.767c-0.288-0.774-0.936-2.052-1.368-3.007
			l1.44-0.522c0.468,0.936,1.099,2.143,1.44,2.899L126.226,54.767z M140.144,54.624h-11.325v-1.314h5.042
			c-0.252-0.504-0.631-1.188-1.009-1.693l1.603-0.522c0.469,0.594,0.99,1.404,1.242,1.927l-0.828,0.288h5.275V54.624z
			 M129.99,60.313h8.75v4.375h-8.75V60.313z M138.614,56.874h-8.427v-1.243h8.427V56.874z M130.187,57.972h8.427v1.243h-8.427
			V57.972z M131.574,63.446h5.527v-1.891h-5.527V63.446z"
          />
          <path
            fill="#FCFAEE"
            d="M147.792,64.292h-3.745v1.531h-1.549V52.391h5.294V64.292z M144.046,53.903v3.619h2.179v-3.619
			H144.046z M146.225,62.798v-3.799h-2.179v3.799H146.225z M154.04,54.785v2.053h3.763v1.458h-1.458v1.729h1.927v1.477h-1.927v4.429
			c0,0.864-0.198,1.314-0.793,1.548c-0.63,0.27-1.566,0.288-2.952,0.288c-0.072-0.45-0.324-1.116-0.559-1.566
			c1.009,0.036,1.999,0.036,2.287,0.036c0.288-0.018,0.378-0.09,0.378-0.342v-4.393h-6.536v-1.477h6.536v-1.729h-5.888v-1.458h3.564
			v-2.053h-4.267v-1.494h4.267v-2.053h1.657v2.053h4.303v1.494H154.04z M150.474,61.952c0.792,0.9,1.782,2.143,2.251,2.971
			l-1.477,0.882c-0.414-0.81-1.368-2.143-2.161-3.097L150.474,61.952z"
          />
          <path
            fill="#FCFAEE"
            d="M175.964,56.55h-4.447v8.841c0,1.116-0.288,1.603-0.973,1.873
			c-0.702,0.288-1.818,0.324-3.601,0.324c-0.072-0.486-0.342-1.279-0.576-1.765c1.188,0.054,2.448,0.036,2.809,0.036
			c0.36-0.018,0.504-0.126,0.504-0.468v-8.319c-2.034,3.385-5.329,6.806-8.552,8.679c-0.288-0.468-0.829-1.116-1.314-1.512
			c3.114-1.566,6.212-4.609,8.156-7.688h-7.58v-1.71h9.29v-3.583h1.837v3.583h4.447V56.55z"
          />
          <path
            fill="#FCFAEE"
            d="M194,54.011c-0.721,0.648-1.603,1.332-2.358,1.854c0.864,0.468,1.818,0.864,2.845,1.134
			c-0.324,0.306-0.774,0.918-1.009,1.314c-0.828-0.252-1.62-0.594-2.341-1.008v2.035c0,0.414,0.055,0.54,0.307,0.54h1.116
			c0.252,0,0.685-0.018,0.882-0.072c0.019,0.342,0.055,0.828,0.108,1.17c-0.198,0.072-0.594,0.09-0.954,0.09h-1.314
			c-1.261,0-1.513-0.504-1.513-1.747V57.9h-2.106v0.072c0,1.207-0.36,2.647-1.944,3.583c-0.198-0.27-0.685-0.738-1.009-0.972v0.288
			h-3.673c-0.072,0.522-0.145,1.063-0.234,1.548h3.943c0,0-0.018,0.432-0.054,0.648c-0.216,2.467-0.414,3.547-0.864,4.015
			c-0.343,0.342-0.721,0.45-1.278,0.486c-0.486,0.054-1.404,0.036-2.377,0c-0.036-0.432-0.234-1.026-0.504-1.422
			c0.954,0.09,1.891,0.108,2.25,0.108c0.307,0,0.486-0.018,0.648-0.162c0.234-0.216,0.414-0.9,0.559-2.413h-3.943
			c0.234-1.099,0.504-2.755,0.648-4.087h3.385v-1.621h-2.791V57.72c-0.612,0.306-1.242,0.576-1.854,0.792
			c-0.198-0.36-0.594-0.954-0.9-1.242c1.135-0.342,2.287-0.882,3.295-1.548c-0.504-0.45-1.242-0.972-1.854-1.351l0.954-0.9
			c0.666,0.378,1.495,0.936,2.035,1.386c0.558-0.468,1.026-1.008,1.422-1.566h-3.889v-1.333h4.771l0.27-0.054l1.063,0.504
			c-0.774,1.765-2.053,3.169-3.564,4.249h2.538v3.799c1.333-0.738,1.53-1.674,1.53-2.521v-1.35h3.745
			c-1.729-1.243-3.061-2.881-3.961-4.861l1.333-0.396c0.323,0.685,0.72,1.333,1.188,1.945c0.721-0.558,1.549-1.314,2.035-1.891
			l1.206,0.864c-0.756,0.702-1.656,1.404-2.413,1.927c0.36,0.36,0.738,0.666,1.152,0.972c0.774-0.576,1.693-1.404,2.251-1.98
			L194,54.011z M192.686,62.06c-0.486,1.333-1.225,2.395-2.161,3.241c0.883,0.522,1.693,1.026,2.27,1.423l-0.864,1.098
			c-0.631-0.468-1.531-1.044-2.539-1.657c-1.171,0.756-2.539,1.278-4.052,1.639c-0.144-0.378-0.468-0.918-0.737-1.225
			c1.278-0.234,2.448-0.648,3.475-1.206c-0.918-0.558-1.854-1.099-2.683-1.566l0.756-0.864h-0.63v-1.188h5.978l0.252-0.036
			L192.686,62.06z M186.331,62.942c0.899,0.486,1.944,1.044,2.952,1.638c0.559-0.486,1.045-1.026,1.44-1.638H186.331z"
          />
          <path
            fill="#FCFAEE"
            d="M202.547,63.212c-2.25,0.684-4.646,1.368-6.445,1.891l-0.414-1.603
			c0.756-0.162,1.692-0.414,2.7-0.684v-4.033h-2.16v-1.549h2.16v-3.511h-2.341v-1.549h6.176v1.549h-2.214v3.511h2.034v1.549h-2.034
			v3.583l2.305-0.648L202.547,63.212z M210.74,66.219c0.379,0,0.45-0.27,0.505-2.088c0.323,0.27,0.99,0.522,1.404,0.63
			c-0.145,2.305-0.54,2.899-1.711,2.899h-1.566c-1.44,0-1.782-0.468-1.782-1.962v-3.799h-1.477c-0.324,2.881-1.225,4.879-4.88,5.996
			c-0.162-0.396-0.594-1.062-0.936-1.368c3.223-0.846,3.907-2.377,4.177-4.627h-1.477v-9.903h8.553v9.903h-2.358v3.781
			c0,0.486,0.071,0.54,0.45,0.54H210.74z M204.564,54.875h5.33v-1.495h-5.33V54.875z M204.564,57.684h5.33v-1.512h-5.33V57.684z
			 M204.564,60.493h5.33V58.98h-5.33V60.493z"
          />
          <path
            fill="#FCFAEE"
            d="M219.792,64.292h-3.745v1.531h-1.549V52.391h5.294V64.292z M216.046,53.903v3.619h2.179v-3.619
			H216.046z M218.225,62.798v-3.799h-2.179v3.799H218.225z M226.04,54.785v2.053h3.763v1.458h-1.458v1.729h1.927v1.477h-1.927v4.429
			c0,0.864-0.198,1.314-0.793,1.548c-0.63,0.27-1.566,0.288-2.952,0.288c-0.072-0.45-0.324-1.116-0.559-1.566
			c1.009,0.036,1.999,0.036,2.287,0.036c0.288-0.018,0.378-0.09,0.378-0.342v-4.393h-6.536v-1.477h6.536v-1.729h-5.888v-1.458h3.564
			v-2.053h-4.267v-1.494h4.267v-2.053h1.657v2.053h4.303v1.494H226.04z M222.474,61.952c0.792,0.9,1.782,2.143,2.251,2.971
			l-1.477,0.882c-0.414-0.81-1.368-2.143-2.161-3.097L222.474,61.952z"
          />
          <path
            fill="#FCFAEE"
            d="M234.407,58.242v9.543h-1.657V51.977h6.645v6.266H234.407z M234.407,53.237v1.242h3.402v-1.242
			H234.407z M237.809,57v-1.333h-3.402V57H237.809z M247.623,65.697c0,0.954-0.198,1.494-0.847,1.782
			c-0.63,0.27-1.62,0.288-3.133,0.288c-0.072-0.45-0.306-1.17-0.522-1.638h-4.861v0.9h-1.53v-7.544h6.752v6.59
			c0.883,0.036,1.747,0.018,2.035,0.018c0.323-0.018,0.414-0.108,0.414-0.414v-7.4h-5.114v-6.302h6.807V65.697z M238.259,60.745
			v1.404h3.655v-1.404H238.259z M241.915,64.868v-1.494h-3.655v1.494H241.915z M242.418,53.237v1.242h3.512v-1.242H242.418z
			 M245.93,57.036v-1.369h-3.512v1.369H245.93z"
          />
          <path
            fill="#FCFAEE"
            d="M260.22,54.191c-0.378,0.612-0.756,1.243-1.188,1.855v11.721h-1.819v-9.453
			c-1.729,1.926-3.816,3.637-6.14,4.861c-0.27-0.45-0.792-1.134-1.152-1.495c3.421-1.674,6.374-4.555,8.103-7.49h-7.599v-1.71
			h15.413v1.71H260.22z M260.365,56.928c2.017,1.35,4.754,3.385,6.067,4.771l-1.404,1.296c-1.206-1.386-3.871-3.529-5.924-4.987
			L260.365,56.928z"
          />
          <path
            fill="#FCFAEE"
            d="M284.306,63.716h-7.382v4.051h-1.711v-4.051h-7.184v-1.584h7.184v-2.395h-5.347v-7.67h12.495v7.67
			h-5.438v2.395h7.382V63.716z M271.504,55.182h9.129v-1.639h-9.129V55.182z M271.504,58.26h9.129v-1.692h-9.129V58.26z"
          />
          <path
            fill="#FCFAEE"
            d="M287.669,62.023c1.387-0.522,2.196-1.35,2.287-2.431c-0.072,0.018-0.162,0.018-0.252,0.018
			c-0.811,0-1.513-0.504-1.513-1.44c0-0.918,0.702-1.44,1.53-1.44c1.135,0,1.729,0.882,1.729,2.25c0,1.999-1.261,3.547-3.313,4.213
			L287.669,62.023z"
          />
          <path
            fill="#FCFAEE"
            d="M298.289,61.826v-4.213c-0.702,1.296-1.566,2.467-2.448,3.223c-0.253-0.378-0.757-0.9-1.099-1.188
			c1.26-0.9,2.521-2.629,3.277-4.339h-2.846v-1.422h3.115V51.31h1.585v2.575h2.7v1.422h-2.7v0.864
			c0.684,0.414,2.466,1.71,2.935,2.052l-0.9,1.369c-0.432-0.45-1.297-1.242-2.034-1.873v4.087L298.289,61.826z M294.94,66.075
			c0.702-0.954,1.296-2.449,1.638-3.691l1.477,0.594c-0.359,1.242-0.936,2.845-1.603,3.853L294.94,66.075z M305.203,65.913
			c0.847,0,0.973-0.252,1.08-2.053c0.36,0.271,1.045,0.504,1.513,0.612c-0.234,2.377-0.702,2.935-2.467,2.935h-3.511
			c-2.161,0-2.719-0.45-2.719-2.035V62.69h1.656v2.665c0,0.486,0.18,0.558,1.206,0.558H305.203z M302.7,61.321
			c0.811,0.756,1.909,1.818,2.467,2.467l-1.225,1.026c-0.504-0.667-1.584-1.783-2.395-2.593L302.7,61.321z M310.424,61.609h-7.112
			v-9.417h7.112V61.609z M308.822,53.543h-3.979v1.369h3.979V53.543z M308.822,56.19h-3.979v1.404h3.979V56.19z M308.822,58.854
			h-3.979v1.422h3.979V58.854z M309.164,62.114c0.738,1.116,1.729,2.646,2.197,3.565l-1.549,0.792
			c-0.432-0.936-1.387-2.521-2.106-3.673L309.164,62.114z"
          />
          <path
            fill="#FCFAEE"
            d="M312.652,59.359c0.45-1.207,0.773-3.187,0.9-4.627l1.224,0.18c-0.09,1.476-0.414,3.565-0.864,4.879
			L312.652,59.359z M317.909,58.063c-0.18-0.792-0.647-2.017-1.134-3.043v12.748h-1.639V51.256h1.639v3.313l0.99-0.414
			c0.559,1.044,1.17,2.449,1.368,3.313L317.909,58.063z M329.378,59.341v1.584h-5.582c-0.504,2.557-1.836,5.095-5.095,6.932
			c-0.234-0.342-0.793-0.991-1.188-1.296c2.971-1.477,4.141-3.529,4.591-5.636h-3.925v-1.584h4.159
			c0.054-0.684,0.072-1.369,0.072-1.999v-1.747h-3.313v-1.548h3.313v-2.791h1.692v2.791h3.925v5.293H329.378z M324.103,57.342
			c0,0.648-0.018,1.314-0.09,1.999h2.377v-3.745h-2.287V57.342z M325.561,61.231c1.243,1.764,2.917,4.177,3.764,5.618l-1.53,0.864
			c-0.757-1.458-2.396-3.943-3.638-5.798L325.561,61.231z"
          />
          <path
            fill="#FCFAEE"
            d="M330.723,67.191c0.685-0.738,1.045-2.017,1.207-3.205l1.152,0.306
			c-0.198,1.314-0.505,2.683-1.261,3.493L330.723,67.191z M331.047,61.952c0.919-0.036,2.053-0.072,3.295-0.126v-1.17h-2.881v-1.296
			h2.881v-1.026h-2.809v-6.482h7.238v6.482h-2.935v1.026h2.988v1.296h-2.988v1.098c1.08-0.054,2.196-0.108,3.295-0.162l-0.055,1.333
			c-2.862,0.198-5.852,0.342-7.958,0.468L331.047,61.952z M332.794,57.162h1.746v-4.141h-1.746V57.162z M333.695,53.651
			c0.288,0.828,0.54,1.945,0.576,2.629l-0.811,0.252c-0.036-0.72-0.234-1.836-0.522-2.683L333.695,53.651z M334.504,63.932
			c0.271,0.972,0.45,2.25,0.45,3.097l-1.116,0.144c0-0.846-0.162-2.125-0.378-3.133L334.504,63.932z M336.215,63.77
			c0.396,0.9,0.756,2.089,0.882,2.881l-1.08,0.252c-0.09-0.792-0.45-1.999-0.828-2.935L336.215,63.77z M337.458,53.021h-1.837v4.141
			h1.837V53.021z M335.765,56.352c0.27-0.738,0.594-1.963,0.738-2.755l0.918,0.342c-0.342,0.9-0.684,1.999-0.99,2.665
			L335.765,56.352z M337.925,63.374c0.631,0.828,1.243,1.962,1.495,2.719l-1.099,0.468c-0.234-0.774-0.828-1.945-1.404-2.791
			L337.925,63.374z M343.742,56.622v3.079h2.988v7.995h-1.584v-0.702h-3.997v0.774h-1.53v-8.066h2.502v-8.426h1.621v3.799h3.673
			v1.549H343.742z M345.146,61.231h-3.997v4.231h3.997V61.231z"
          />
          <path
            fill="#FCFAEE"
            d="M364.659,51.94v15.845h-1.801v-0.972h-11.506v0.972h-1.729V51.94H364.659z M362.858,65.247V53.651
			h-11.506v11.596H362.858z M360.625,56.118v6.608h-7.095v-6.608H360.625z M358.951,57.594h-3.835v3.673h3.835V57.594z"
          />
          <path
            fill="#FCFAEE"
            d="M79.556,81.876c-1.099,1.783-2.413,3.493-3.655,4.879l8.12-0.522
			c-0.702-1.008-1.458-2.035-2.196-2.881l1.512-0.684c1.603,1.764,3.313,4.123,4.124,5.726l-1.657,0.864
			c-0.198-0.45-0.485-0.972-0.828-1.53c-9.398,0.756-10.497,0.81-11.271,1.116c-0.09-0.36-0.359-1.207-0.576-1.657
			c0.414-0.108,0.811-0.504,1.333-1.116c0.486-0.486,1.872-2.287,2.971-4.195H72.03v-1.674h7.147v-3.025h-5.743v-1.675h5.743v-2.665
			h1.765v2.665h5.906v1.675h-5.906v3.025h7.221v1.674H79.556z"
          />
          <path
            fill="#FCFAEE"
            d="M105.802,75.647c0,0,0,0.576-0.019,0.792c-0.252,8.121-0.468,10.911-1.188,11.812
			c-0.45,0.594-0.883,0.756-1.567,0.846c-0.63,0.072-1.692,0.054-2.719,0c-0.035-0.45-0.233-1.152-0.54-1.621
			c1.152,0.09,2.197,0.108,2.647,0.108c0.359,0,0.558-0.054,0.756-0.306c0.576-0.594,0.811-3.313,1.044-10.101h-4.249
			c-0.504,1.152-1.063,2.197-1.639,3.025c-0.27-0.252-0.9-0.702-1.314-0.937v8.265h-4.879v1.369h-1.53V75.737h2.017
			c0.252-0.864,0.521-2.053,0.63-2.917l1.818,0.306c-0.306,0.9-0.648,1.854-0.937,2.611h2.881v3.403
			c1.188-1.548,2.143-3.943,2.684-6.32l1.62,0.378c-0.216,0.829-0.45,1.657-0.738,2.449H105.802z M92.136,77.195v3.421h3.349v-3.421
			H92.136z M95.485,86.054v-3.979h-3.349v3.979H95.485z M101.481,84.649c-0.504-1.098-1.675-2.863-2.629-4.159l1.314-0.738
			c0.954,1.242,2.179,2.953,2.719,4.015L101.481,84.649z"
          />
          <path
            fill="#FCFAEE"
            d="M113.287,73.414c-0.485,1.333-1.134,2.647-1.836,3.907v12.045h-1.585V79.77
			c-0.486,0.666-0.99,1.278-1.494,1.8c-0.162-0.414-0.648-1.314-0.918-1.692c1.692-1.674,3.295-4.303,4.267-6.932L113.287,73.414z
			 M121.498,87.729c1.063,0,1.242-0.468,1.404-2.539c0.396,0.27,1.044,0.541,1.494,0.63c-0.252,2.557-0.756,3.403-2.809,3.403h-4.43
			c-2.305,0-2.952-0.558-2.952-2.773v-5.474l-1.585,0.612l-0.666-1.477l2.251-0.882v-4.465h1.566v3.853l2.305-0.9v-4.79h1.494v4.195
			l2.701-1.062l0.233-0.18l1.261,0.414l-0.054,0.288c-0.072,2.575-0.271,5.96-0.612,8.103l-1.387-0.378
			c0.198-1.584,0.307-4.159,0.36-6.446l-2.503,0.99v6.464h-1.494v-5.888l-2.305,0.918v6.122c0,1.044,0.216,1.261,1.458,1.261
			H121.498z"
          />
          <path
            fill="#FCFAEE"
            d="M129.037,79.41c-0.271,2.215-0.793,5.258-1.477,7.22l-1.675-0.702
			c0.702-1.854,1.278-4.591,1.513-6.824L129.037,79.41z M132.133,77.897v8.588c0,0.846,0.198,0.99,1.152,0.99h3.043
			c1.026,0,1.188-0.594,1.314-3.565c0.396,0.306,1.134,0.612,1.566,0.72c-0.198,3.385-0.685,4.411-2.772,4.411h-3.331
			c-2.107,0-2.701-0.576-2.701-2.557v-8.588H132.133z M132.277,73.342c1.657,1.098,3.854,2.719,4.916,3.853l-1.242,1.278
			c-0.99-1.116-3.133-2.863-4.808-4.015L132.277,73.342z M140.074,78.582c1.044,2.143,1.998,4.861,2.377,6.698l-1.675,0.702
			c-0.324-1.837-1.278-4.664-2.251-6.788L140.074,78.582z"
          />
          <path
            fill="#FCFAEE"
            d="M154.148,75.791c-0.378,0.612-0.756,1.243-1.188,1.855v11.721h-1.819v-9.453
			c-1.729,1.926-3.816,3.637-6.14,4.861c-0.27-0.45-0.792-1.134-1.152-1.495c3.421-1.674,6.374-4.555,8.103-7.49h-7.599v-1.71
			h15.413v1.71H154.148z M154.292,78.528c2.017,1.35,4.754,3.385,6.067,4.771l-1.404,1.296c-1.206-1.386-3.871-3.529-5.924-4.987
			L154.292,78.528z"
          />
          <path
            fill="#FCFAEE"
            d="M177.928,75.485v1.603h-9.687c-0.612,1.278-1.314,2.502-2.143,3.619v8.643h-1.675v-6.698
			c-0.576,0.558-1.206,1.098-1.873,1.566c-0.18-0.45-0.558-1.17-0.828-1.566c1.98-1.351,3.511-3.367,4.628-5.563h-4.142v-1.603
			h4.861c0.378-0.882,0.648-1.765,0.883-2.647l1.746,0.432c-0.234,0.738-0.486,1.477-0.774,2.215H177.928z M173.391,87.386h4.519
			v1.566h-10.749v-1.566h4.538v-4.646h-3.854v-1.548h3.854v-3.241h1.692v3.241h3.835v1.548h-3.835V87.386z"
          />
          <path
            fill="#FCFAEE"
            d="M184.855,80.004c-0.054,0.36-0.126,0.702-0.18,1.081h9.938v1.278h-10.173
			c-0.072,0.36-0.145,0.738-0.216,1.08h11.307c0,0-0.018,0.432-0.036,0.63c-0.197,3.007-0.378,4.25-0.828,4.735
			c-0.324,0.36-0.647,0.468-1.152,0.522c-0.396,0.054-1.188,0.054-2.017,0.018c-0.036-0.432-0.198-1.044-0.432-1.44
			c0.72,0.072,1.404,0.072,1.675,0.072c0.27,0,0.414-0.018,0.558-0.18c0.234-0.234,0.396-1.063,0.54-3.043h-9.885l-1.675,0.018
			c0.288-1.242,0.667-3.169,0.919-4.771h-2.989v-1.314h2.755v-2.845h1.549v2.845h2.7v-3.511h-6.41v-1.296h14.639v1.296h-6.59v1.08
			h5.329v1.243h-5.329v1.188h7.058v1.314H184.855z M180.299,88.539c0.595-0.81,1.116-2.125,1.387-3.151l1.368,0.558
			c-0.342,1.044-0.774,2.377-1.387,3.223L180.299,88.539z M185.539,85.712c0.307,0.936,0.541,2.178,0.612,2.971l-1.404,0.252
			c-0.036-0.792-0.27-2.07-0.54-3.007L185.539,85.712z M188.366,85.478c0.414,0.846,0.828,1.963,0.954,2.665l-1.314,0.414
			c-0.126-0.72-0.485-1.854-0.899-2.719L188.366,85.478z M191.103,87.764c-0.198-0.612-0.738-1.548-1.242-2.232l1.134-0.45
			c0.522,0.666,1.08,1.566,1.314,2.161L191.103,87.764z"
          />
          <path
            fill="#FCFAEE"
            d="M203.431,82.453l0.396,1.477c-1.891,0.9-3.907,1.836-5.475,2.539l-0.666-1.674
			c0.648-0.234,1.477-0.558,2.395-0.937v-5.186h-2.052v-1.584h2.052V73.09h1.567v3.998h1.818v1.584h-1.818v4.538L203.431,82.453z
			 M211.624,87.512c0.99,0,1.17-0.45,1.314-2.413c0.378,0.252,1.026,0.522,1.477,0.612c-0.234,2.484-0.738,3.295-2.683,3.295h-4.142
			c-2.215,0-2.845-0.558-2.845-2.719v-5.204l-1.242,0.54l-0.631-1.495l1.873-0.792v-4.771h1.584v4.105l2.017-0.846v-4.951h1.566
			v4.285l2.413-1.026l1.242,0.414l-0.072,0.27c-0.144,2.503-0.414,5.798-0.864,7.851l-1.368-0.378
			c0.271-1.549,0.469-4.051,0.559-6.248l-1.909,0.828v6.464h-1.566v-5.798L206.33,80.4v5.906c0,1.008,0.198,1.206,1.351,1.206
			H211.624z"
          />
          <path
            fill="#FCFAEE"
            d="M220.386,83.407c-0.449,0.09-0.972,0.18-1.512,0.234v1.225h1.134v1.08h-1.134v1.044l1.404-0.162
			l0.018,1.17l-4.267,0.54l-0.162-1.242c0.504-0.036,1.098-0.09,1.729-0.162v-1.188h-1.225v-1.08h1.225v-1.117
			c-0.45,0.036-0.864,0.036-1.261,0.036c-0.036-0.27-0.162-0.666-0.288-0.954c1.242-0.09,2.791-0.234,3.728-0.432L220.386,83.407z
			 M222.187,74.944v14.44h-1.53v-7.67c-1.675,0.126-3.313,0.271-4.609,0.342l-0.144-1.333l1.025-0.054v-5.726h-0.99v-1.332h7.131
			v1.332H222.187z M220.657,74.944h-2.232v1.117h2.232V74.944z M220.657,77.141h-2.232v1.099h2.232V77.141z M218.424,80.58
			c0.702-0.036,1.477-0.09,2.232-0.144V79.32h-2.232V80.58z M222.223,87.854c0.576-0.792,1.099-2.107,1.387-3.079l1.134,0.45
			c-0.306,1.063-0.792,2.449-1.404,3.349L222.223,87.854z M232.252,83.443h-9.417v-1.422h9.417V83.443z M226.382,76.763
			c0.055-0.342,0.108-0.72,0.181-1.116h-3.476v-1.314h3.673c0.055-0.468,0.126-0.955,0.162-1.387l1.44,0.072
			c-0.054,0.414-0.107,0.864-0.18,1.314H232v1.314h-4.033c-0.055,0.396-0.126,0.774-0.181,1.116h3.907v4.339h-8.3v-4.339H226.382z
			 M225.861,77.987h-1.188v1.891h1.188V77.987z M228.633,87.836c0.45,0,0.54-0.18,0.594-1.548c0.288,0.216,0.864,0.414,1.261,0.504
			c-0.145,1.854-0.54,2.323-1.692,2.323h-2.035c-1.494,0-1.854-0.396-1.854-1.729v-2.593h1.404v2.593c0,0.378,0.091,0.45,0.612,0.45
			H228.633z M226.977,83.497c0.81,0.738,1.656,1.836,2.017,2.557l-1.152,0.667c-0.36-0.756-1.225-1.909-1.945-2.665L226.977,83.497z
			 M228.093,77.987h-1.242v1.891h1.242V77.987z M229.083,79.878h1.296v-1.891h-1.296V79.878z M230.542,84.416
			c0.919,1.008,1.692,2.395,1.98,3.385l-1.26,0.576c-0.234-0.99-0.99-2.431-1.873-3.439L230.542,84.416z"
          />
          <path
            fill="#FCFAEE"
            d="M247.965,87.584c0.612,0,0.721-0.306,0.792-2.287c0.379,0.288,1.081,0.559,1.513,0.667
			c-0.18,2.521-0.63,3.151-2.16,3.151h-2.539c-1.837,0-2.269-0.486-2.269-2.143v-4.033h-2.827c-0.252,3.601-1.152,5.527-5.707,6.464
			c-0.145-0.432-0.576-1.08-0.883-1.422c4.016-0.72,4.682-2.107,4.88-5.042h-4.646v-1.566h15.862v1.566h-4.987v4.033
			c0,0.54,0.108,0.612,0.792,0.612H247.965z M236.208,78.996h-1.675v-4.177h6.752c-0.198-0.54-0.486-1.152-0.756-1.638l1.692-0.504
			c0.396,0.648,0.81,1.477,1.063,2.143h6.247v4.177h-1.729v-2.575h-11.595V78.996z M237.27,79.608v-1.53h9.489v1.53H237.27z"
          />
          <path
            fill="#FCFAEE"
            d="M258.98,80.796c-0.847,0-1.423-0.054-1.801-0.234c-1.278,0.45-2.593,0.811-3.89,1.117
			c-0.198-0.324-0.612-0.9-0.9-1.188c1.387-0.252,2.791-0.576,4.105-1.008c-0.018-0.126-0.018-0.27-0.018-0.396v-2.413h1.422v2.323
			c2.161-0.846,4.033-1.944,5.258-3.313l1.261,0.576c-1.225,1.369-2.936,2.467-4.826,3.349h2.846c0.702,0,0.846-0.162,0.918-1.152
			c0.324,0.198,0.882,0.396,1.278,0.468c-0.162,1.512-0.63,1.873-2.035,1.873H258.98z M253.992,77.015h-1.512v-2.863h6.896
			c-0.162-0.342-0.36-0.702-0.54-1.008l1.603-0.36c0.252,0.396,0.558,0.937,0.756,1.369h6.446v2.863h-1.566v-1.548h-6.842
			c0.756,0.378,1.566,0.882,2.034,1.26l-0.918,0.9c-0.576-0.504-1.675-1.188-2.539-1.603l0.648-0.558h-4.466V77.015z M264.58,85.874
			c1.242,0.829,2.628,1.945,3.349,2.701l-1.278,0.882c-0.271-0.288-0.612-0.612-0.99-0.973c-4.699,0.216-9.633,0.378-12.838,0.468
			l-0.162-1.458c1.746-0.036,4.033-0.09,6.536-0.144v-1.477h-5.042v-3.943h5.042v-0.9h1.656v0.9h5.401v3.943H264.58z
			 M252.803,79.068c0.721-0.558,1.387-1.513,1.765-2.269l1.188,0.576c-0.45,0.846-1.063,1.854-1.801,2.521L252.803,79.068z
			 M259.196,84.595v-1.386h-3.403v1.386H259.196z M260.852,83.209v1.386h3.655v-1.386H260.852z M264.093,87.188
			c-0.378-0.27-0.774-0.558-1.135-0.81l0.883-0.504h-2.989v1.423L264.093,87.188z M264.813,76.925
			c1.045,0.648,2.305,1.674,2.899,2.449l-1.242,0.774c-0.541-0.756-1.747-1.836-2.81-2.539L264.813,76.925z"
          />
          <path
            fill="#FCFAEE"
            d="M284.992,74.765c-0.558,1.422-1.44,2.593-2.503,3.565c1.207,0.72,2.611,1.278,4.142,1.584
			c-0.324,0.306-0.774,0.936-0.99,1.314c-1.62-0.378-3.079-1.063-4.34-1.963c-1.35,0.955-2.935,1.657-4.573,2.107
			c-0.09-0.252-0.288-0.558-0.485-0.828v2.269h-2.305v3.295l1.152-0.216c-0.145-0.648-0.307-1.296-0.433-1.854l1.206-0.324
			c0.414,1.422,0.828,3.223,0.99,4.447l-1.278,0.378c-0.036-0.378-0.107-0.81-0.197-1.26c-1.873,0.396-3.764,0.792-5.294,1.098
			l-0.324-1.548c0.774-0.108,1.746-0.27,2.772-0.468v-3.547h-0.99v0.756h-1.206v-7.4h2.196v-3.097h1.405v3.097h2.305v0.9
			c1.494-0.991,2.79-2.521,3.528-4.231l1.459,0.378c-0.162,0.396-0.36,0.774-0.595,1.152h3.098l0.27-0.072L284.992,74.765z
			 M271.542,81.444h1.116v-3.907h-1.116V81.444z M275.017,77.537h-1.225v3.907h1.225V77.537z M276.242,80.058
			c1.386-0.36,2.754-0.937,3.942-1.71c-0.521-0.468-0.954-0.99-1.368-1.548c-0.468,0.504-0.99,0.972-1.494,1.332
			c-0.234-0.198-0.721-0.612-1.08-0.864V80.058z M282.075,85.892h4.016v1.279h-4.016v2.178h-1.566V87.17h-3.727v-1.279h3.727V84.83
			h-2.826v-1.207h2.826v-1.008h-3.15v-1.224h3.15V80.13h1.566v1.261h3.241v1.224h-3.241v1.008h2.917v1.207h-2.917V85.892z
			 M279.789,75.647l-0.072,0.09c0.414,0.63,0.954,1.224,1.584,1.765c0.648-0.541,1.188-1.17,1.603-1.854H279.789z"
          />
          <path
            fill="#FCFAEE"
            d="M302.524,87.638c0.324,0,0.396-0.252,0.45-2.053c0.324,0.288,1.008,0.559,1.44,0.667
			c-0.162,2.323-0.576,2.917-1.692,2.917h-1.351c-1.404,0-1.711-0.486-1.711-2.035v-3.997h-1.188
			c-0.27,2.827-0.972,5.059-3.745,6.338c-0.162-0.396-0.63-0.991-0.972-1.297c2.358-0.99,2.881-2.791,3.097-5.041h-1.368v-5.096
			c-0.252,0.288-0.522,0.558-0.757,0.774c-0.27-0.306-0.899-0.882-1.242-1.17c0.162-0.144,0.324-0.288,0.486-0.45h-6.158v-1.333
			h6.302v1.207c1.099-1.063,2.107-2.521,2.737-3.979l1.549,0.486c-0.648,1.458-1.566,2.899-2.558,4.087h6.717
			c-0.828-1.261-2.035-2.773-3.098-3.961l1.152-0.792c1.405,1.495,3.079,3.493,3.8,4.826l-1.278,0.918
			c-0.145-0.306-0.343-0.63-0.576-0.973v5.456h-1.278v3.979c0,0.468,0.054,0.522,0.359,0.522H302.524z M293.683,88.34h-3.728v0.811
			h-1.458v-6.086h5.186V88.34z M293.485,79.572h-4.951v-1.314h4.951V79.572z M288.534,80.634h4.951v1.296h-4.951V80.634z
			 M290.694,75.845c-0.162-0.648-0.612-1.674-1.008-2.413l1.422-0.468c0.415,0.72,0.864,1.692,1.063,2.341L290.694,75.845z
			 M289.956,84.416v2.575h2.323v-2.575H289.956z M297.068,81.679h3.835V79.14h-3.835V81.679z"
          />
          <path
            fill="#FCFAEE"
            d="M321.802,75.647c0,0,0,0.576-0.019,0.792c-0.252,8.121-0.468,10.911-1.188,11.812
			c-0.45,0.594-0.883,0.756-1.567,0.846c-0.63,0.072-1.692,0.054-2.719,0c-0.035-0.45-0.233-1.152-0.54-1.621
			c1.152,0.09,2.197,0.108,2.647,0.108c0.359,0,0.558-0.054,0.756-0.306c0.576-0.594,0.811-3.313,1.044-10.101h-4.249
			c-0.504,1.152-1.063,2.197-1.639,3.025c-0.27-0.252-0.9-0.702-1.314-0.937v8.265h-4.879v1.369h-1.53V75.737h2.017
			c0.252-0.864,0.521-2.053,0.63-2.917l1.818,0.306c-0.306,0.9-0.648,1.854-0.937,2.611h2.881v3.403
			c1.188-1.548,2.143-3.943,2.684-6.32l1.62,0.378c-0.216,0.829-0.45,1.657-0.738,2.449H321.802z M308.136,77.195v3.421h3.349
			v-3.421H308.136z M311.485,86.054v-3.979h-3.349v3.979H311.485z M317.481,84.649c-0.504-1.098-1.675-2.863-2.629-4.159
			l1.314-0.738c0.954,1.242,2.179,2.953,2.719,4.015L317.481,84.649z"
          />
          <path
            fill="#FCFAEE"
            d="M327.108,75.863h3.422v1.333h-6.698v-1.333h3.241c-0.253-0.666-0.793-1.692-1.261-2.431
			l1.278-0.666c0.522,0.756,1.08,1.71,1.368,2.358L327.108,75.863z M330.007,88.34h-4.016v0.811h-1.44v-6.086h5.456V88.34z
			 M329.899,79.572h-5.329v-1.314h5.329V79.572z M324.57,80.634h5.329v1.296h-5.329V80.634z M325.992,84.416v2.575h2.557v-2.575
			H325.992z M336.219,79.878v2.755h3.169v6.662h-1.603v-0.594h-4.682v0.666h-1.53v-6.734h3.097v-2.755h-3.817v-1.584h3.817v-2.917
			c-1.08,0.18-2.16,0.306-3.169,0.414c-0.054-0.396-0.27-0.99-0.432-1.368c2.61-0.306,5.617-0.828,7.382-1.477l1.044,1.351
			c-0.936,0.324-2.07,0.594-3.276,0.828v3.169h4.087v1.584H336.219z M337.786,84.163h-4.682v3.007h4.682V84.163z"
          />
          <path
            fill="#FCFAEE"
            d="M345.614,78.33c1.566,0,2.809,1.26,2.809,2.809c0,1.549-1.242,2.809-2.809,2.809
			c-1.549,0-2.809-1.26-2.809-2.809C342.805,79.59,344.065,78.33,345.614,78.33z M345.614,82.867c0.954,0,1.729-0.774,1.729-1.729
			c0-0.954-0.774-1.729-1.729-1.729c-0.937,0-1.729,0.774-1.729,1.729C343.885,82.093,344.677,82.867,345.614,82.867z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonGText;



// WEBPACK FOOTER //
// ./src/storyC/components/ButtonGText.tsx